import { DLCenter } from './DLCenter';

var $ = require('jquery');
require('magnific-popup');


// This module could use some love, quick and dirty
export module DownloadCenter {
  export function init() {
    var dlcenter = new DLCenter(),
        toggleProductInCart,
        updateToggleGroup,
        toggleClass = 'js-product-add-to-cart',
        toggleAddedClass = toggleClass + '--added',
        $dlcenter = $('#js-dlcenter'),
        $itemCount,
        $generatingPopup;

    toggleProductInCart = function($el, isInCart) {
      if (isInCart) {
        $el.addClass(toggleAddedClass);
        $el.text($el.data('remove-text'));
      } else {
        $el.removeClass(toggleAddedClass);
        $el.text($el.data('add-text'));
      }
    }

    // Find toggle buttons on product pages
    $('.' + toggleClass).each(function() {
      var $this = $(this);

      if (dlcenter.isInCart($this.data('item'))) {
        toggleProductInCart($this, true);
      } else {
        toggleProductInCart($this, false);
      }

      $this.on('click', function(e) {
        var action;

        e.preventDefault();

        if ($this.hasClass(toggleAddedClass)) {
          dlcenter.removeItems($this.data('item')).then(function(res) {
            toggleProductInCart($this, false);
          });
          //action = 'remove';
        } else {
          dlcenter.addItems($this.data('item')).then(function(res) {
            toggleProductInCart($this, true);
          });
          //action = 'add';
        }
      });
    });


    updateToggleGroup = function($toggles, groupItems, allChecked) {
      var itemsObj = {},
        i, l;

      for (i = 0, l = groupItems.length; i < l; i++) {
        itemsObj[groupItems[i]] = true;
      }

      $toggles.each(function() {
        var $this = $(this),
          isGroupToggle = $(this).data('group-toggle'),
          ids = $this.data('ids')[0];

        if(typeof ids === 'object' && ids) {
          ids = JSON.stringify(ids);
        }

        if (!isGroupToggle && itemsObj[ids]) {
          if (allChecked) {
            $this.prop('checked', 'checked');
          } else {
            $this.prop('checked', '');
          }
        }
      });
    }

    function updateCartItemCount() {
      $itemCount.text(dlcenter.getItemCount());
    }

    // Main dlcenter functionality
    if ($dlcenter.length) {
      var $dlcenterToggles = $dlcenter.find('.js-dlcenter__toggle'),
          $generateLink = $dlcenter.find('.js-dlcenter__generate-pdf'),
          companyMode = $dlcenter.data('company-mode'),
          customAjaxUrl = $dlcenter.data('dlcenter-ajax');

      // If this is for example extranet product catalogue, we need different handler
      if(customAjaxUrl) {
        dlcenter.setHandlerAjaxUrl(customAjaxUrl);
      }

      $itemCount = $dlcenter.find('.js-dlcenter__item-count');
      $generatingPopup = $dlcenter.find('#js-dlcenter__pdf-generation-popup');

      $dlcenterToggles.on('click', function() {
        var $this = $(this),
            ids = $this.data('ids'),
            isGroupToggle = $this.data('group-toggle'),
            i, l;

        // Convert to string so we can compare results
        for(i=0, l=ids.length; i<l; i++) {
          if(typeof ids[i] === 'object' && ids[i]) {
            ids[i] = JSON.stringify(ids[i]);
          }
        }


        // If this toggle is the group selector
        if (isGroupToggle) {
          if ($this.is(':checked')) {
            updateToggleGroup($dlcenterToggles, ids, true);
            dlcenter.addItems(ids).then(function(cartItems) {
              updateCartItemCount();
            });
          } else {
            updateToggleGroup($dlcenterToggles, ids, false);
            dlcenter.removeItems(ids).then(function(cartItems) {
              updateCartItemCount();
            });
          }
        } else {
          if ($this.is(':checked')) {
            dlcenter.addItems($this.data('ids')).then(function(cartItems) {
              updateCartItemCount();
            });
          } else {
            dlcenter.removeItems($this.data('ids')).then(function(cartItems) {
              updateCartItemCount();
            });
          }
        }
      });

      // Popup and generation functionality
      (function() {
        var $downloadLink = $dlcenter.find('.js-dlcenter__pdf-download-link'),
          $progress = $dlcenter.find('.js-dlcenter__pdf-progress'),
          $progressBar = $dlcenter.find('.js-dlcenter__pdf-generation-progress-bar'),
          $generationAbort = $dlcenter.find('.js-dlcenter__pdf-generation-abort'),
          $popupCompleted = $generatingPopup.find('.js-dlcenter__pdf-generation-popup--completed'),
          $popupProgress = $generatingPopup.find('.js-dlcenter__pdf-generation-popup--progress'),
          $popupError = $generatingPopup.find('.js-dlcenter__pdf-generation-popup--error'),
          $clearCart = $dlcenter.find('.js-dlcenter__clear-cart');


        var pdfGenerationProgress = function(progress) {
          $progress.show();
          $progress.text(progress + ' %');
          $progressBar.css({ 'width': progress + '%' });
          $popupProgress.show();
          $popupError.hide();
          $popupCompleted.hide();
        }

        var pdfGenerationCompleted = function(downloadLink) {
          $downloadLink.attr('href', downloadLink);
          $downloadLink.show();
          $popupProgress.hide();
          $popupError.hide();
          $popupCompleted.show();
        }

        var pdfGenerationError = function() {
          $popupProgress.hide();
          $popupError.show();
          $popupCompleted.hide();
        }

        // Clear cart and reload view
        $clearCart.on('click', function(e) {
          e.preventDefault();
          dlcenter.clearCart().then(function() {
            // refresh
            //document.location.href = document.location.href;
            location.reload();
          });
        });

        // Abort click
        $generationAbort.on('click', function(e) {
          e.preventDefault();
          dlcenter.abortJob();
          $.magnificPopup.close();
        });

        // If there is job in progress, continue that
        if (dlcenter.isJobInProgress()) {
          $.magnificPopup.open({
            'items': {
              'src': $generateLink.attr('href'),
              'type': 'inline',
              'midClick': true
            }
          });
          dlcenter.continueJob(function(progress) {
            pdfGenerationProgress(progress);
          }).then(function(downloadLink) {
            pdfGenerationCompleted(downloadLink);
          }, function(error) {
            pdfGenerationError();
          });
        }

        // Generate pdf
        $generateLink.on('click', function(e) {

          $.magnificPopup.open({
            'items': {
              'src': $generateLink.attr('href'),
              //'src': '<div>test</div>',
              'type': 'inline',
              'midClick': true
            }
          });

          $progress.hide();
          $downloadLink.hide();
          e.preventDefault();

          dlcenter.generatePdf(function(progress) {
            pdfGenerationProgress(progress);
          }).then(function(downloadLink) {
            pdfGenerationCompleted(downloadLink);
          }, function(error) {
            pdfGenerationError();
          });
        });

      })();
    }
  }
}
